import { useState } from "react"
import {
  Heading,
  useToast,
} from "@chakra-ui/react"
import { NavLayout } from "../components/NavLayout"
import useAxiosPrivate from "../hooks/useAxiosPrivate"
import { useNavigate } from "react-router-dom"
import { ProductForm } from "../components/Forms/ProductForm"
import { addServerErrors } from "../services/add-server-errors"

type FormData = {
  name: string
  options: {
    seat_sizes: string
    tree_sizes: string
    color_and_type_of_leather: string
    flap_position: string
    flap_length: string
    calf_roll_type: string
    calf_roll_size: string
    knee_roll_type: string
    knee_roll_size: string
    panel_type: string
    gusset_depth: string
    billets: string
    girth_color: string
    girth_size: string
    leathers_color: string
    leathers_size: string
    head_type: string
    seat_welting: string
    cantle_welting: string
    front_facing: string
    rear_facing: string
    keeper: string
    keeper_style: string
    cantlepiece: string
    cantlepiece_full_patent: string
    stitching: string
  }
  active: string
}

type Errors = {
  [key: string]: { message: string }
}

const initialFormData: FormData = {
  name: "",
  options: {
    seat_sizes: "",
    tree_sizes: "",
    color_and_type_of_leather: "",
    flap_position: "",
    flap_length: "",
    calf_roll_type: "",
    calf_roll_size: "",
    knee_roll_type: "",
    knee_roll_size: "",
    panel_type: "",
    gusset_depth: "",
    billets: "",
    girth_color: "",
    girth_size: "",
    leathers_color: "",
    leathers_size: "",
    head_type: "",
    seat_welting: "",
    cantle_welting: "",
    front_facing: "",
    rear_facing: "",
    keeper: "",
    keeper_style: "",
    cantlepiece: "",
    cantlepiece_full_patent: "",
    stitching: "",
  },
  active: "1",
}

const initialErrors: Errors = {}

export const AddProduct = () => {
  const axiosPrivate = useAxiosPrivate()
  const navigate = useNavigate()
  const toast = useToast()
  const [errors, setErrors] = useState(initialErrors)
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (formData: FormData) => {
    setLoading(true)
    try {
      const response = await axiosPrivate.post('/products/add', formData)

      if (!response?.data?.user?.errors) {
        toast({
          title: 'Success',
          description: 'Product added successfully!',
          status: 'success',
          isClosable: true,
        })
        navigate(-1)
      } else {
        addServerErrors(response?.data?.user?.errors, setErrors)
        toast({
          title: 'Error',
          description: 'Please review any errors and resubmit',
          status: 'error',
          isClosable: true,
        })
      }
    } catch (e: any) {
      toast({
        title: 'Error',
        description: e.message,
        status: 'error',
        isClosable: true,
      })
    }
    setLoading(false)
  }

  return (
    <NavLayout
      left={
        <Heading as="h1" size="lg">Add Product</Heading>
      }
    >
      <ProductForm errors={errors} handleSubmit={handleSubmit} initialFormData={initialFormData} loading={loading} />
    </NavLayout>
  )
}
